<div class="module-api-search">
  <div class="container-fluid">
    <div class="component-search-term-label show">
      <ng-container *ngIf="!checkEmptyResults && (query != specialSearchingKeyword)">
        <p>{{ 'dc.myrn.top.search-results-for' | translate }} "{{ query }}"</p>
      </ng-container>

      <div class="spelling-results" *ngIf="websiteCount == 0 && downloadCount == 0 && (wbsSpell || dwnSpell)">
        <p *ngIf="checkEmptyResults">
          <span class="bundle">{{ 'dc.myrn.top.search_no_results3' | translate }}</span> "{{ query }}"
        </p>
        <div class="text-holder">
          <h3>
            <ng-container *ngIf="wbsSpell != dwnSpell">
							<span class="bundle">{{
                  'dc.myrn.top.did_you_mean' | translate
                }} </span>
              <a *ngIf="wbsSpell" target="_self" href="{{wbsSuggestionUrl}}" title="{{ wbsSpell }}">"{{
                  wbsSpell
                }}"</a>
              <span class="bundle" *ngIf="wbsSpell && dwnSpell"> or </span>
              <a *ngIf="dwnSpell" target="_self" href="{{dwnSuggestionUrl}}" title="{{ dwnSpell }}">"{{
                  dwnSpell
                }}"</a>
              <span class="bundle">?
							</span>
            </ng-container>
            <ng-container *ngIf="wbsSpell == dwnSpell">
              <span class="bundle">{{ 'dc.myrn.top.did_you_mean' | translate }} </span>
              <a target="_self" href="{{wbsSuggestionUrl}}" title="{{ wbsSpell }}">"{{
                  wbsSpell
                }}"</a>
              <span class="bundle">?
							</span>
            </ng-container>
          </h3>
        </div>
      </div>

      <div class="no-results" *ngIf="checkEmptyResults">
        <div class="text-holder">
          <h3>
            <span class="bundle">{{ 'dc.myrn.top.search_no_results1' | translate }}</span>
            &#8221;{{ query }}&#8221; <span class="bundle">{{
              'dc.myrn.top.search_no_results2' | translate
            }}.</span>
          </h3>
          <h5><strong><span class="bundle">{{ 'dc.myrn.top.before_search1' | translate }}</span></strong></h5>
          <ul class="text-list">
            <li class="text-list-item"><span class="bundle">{{
                'dc.myrn.top.before_search2' | translate
              }}</span></li>
            <li class="text-list-item"><span class="bundle">{{
                'dc.myrn.top.before_search3' | translate
              }}</span></li>
            <li class="text-list-item"><span class="bundle">{{
                'dc.myrn.top.before_search4' | translate
              }}</span></li>
            <li class="text-list-item"><span class="bundle">{{
                'dc.myrn.top.before_search5' | translate
              }}</span></li>
            <li class="text-list-item"><span class="bundle"
                                             [innerHTML]="'dc.myrn.top.before_search6' | translate | constructUrl:('dc.myrn.top.contact_link' | translate)"></span>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
  <div class="module-tab-navigation module-block" data-plugin="moduleTabNavigation">
    <div class="row" *ngIf="!checkEmptyResults">
      <div class="col-12">
        <div class="container-fluid">
          <div class="tab-head">
            <ng-container *ngFor="let nav of navs; trackBy: trackByFn;">
              <div #tabHeadItems class="head-item" [id]="nav.idClass">
                <button type="button" class="btn btn-secondary" (click)="onChangeTabNav(nav)">
                  <ng-container>
                    {{ nav.title | translate }} ({{ math.max(nav.count, 0) }})
                  </ng-container>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="tab-content" modalsOverlayFix>
          <div class="content-item" [attr.data-tab]='catalogTab.selectedTab' (watchForChanges)="watchForChanges($event)">
            <section class="module-text container-fluid">
              <app-product-search></app-product-search>
            </section>
          </div>
          <div class="content-item" [attr.data-tab]='downloadTab.selectedTab' (watchForChanges)="watchForChanges($event)">
            <section class="module-text container-fluid">
              <app-search-result-container></app-search-result-container>
            </section>
          </div>
          <div class="content-item" [attr.data-tab]='websiteTab.selectedTab' (watchForChanges)="watchForChanges($event)">
            <section class="module-text container-fluid">
              <app-website-result-container></app-website-result-container>
            </section>
          </div>
          <app-spinner *ngIf="!(isGlobalLoading | async)" [hasLoadingImg]="false"></app-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
